import { faCamera, faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MessageDetailsFragment } from '../../graphql/types';
import { IMAGE_REGEX } from '../../utils/regex';

export const getMessageDisplayText = (
  message: MessageDetailsFragment | undefined,
  selfId: string | undefined,
) => {
  const words = message?.text.split(/\s/gm).filter((word) => word.length);
  const isReadableMessage =
    (words?.length || 0) > (message?.previews?.length || 0);
  const isImage = new RegExp(IMAGE_REGEX, 'i').test(message?.text || '');

  const isSentBySelf = selfId === message?.user.id;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  let messageText = <>{message?.text}</>;

  if (isReadableMessage && isImage) {
    messageText = (
      <FontAwesomeIcon
        data-testid="message-image-icon"
        icon={faCamera}
        fontSize={12}
      />
    );
  }

  if (!isReadableMessage && !isImage) {
    messageText = (
      <FontAwesomeIcon
        data-testid="message-link-icon"
        icon={faLink}
        fontSize={12}
      />
    );
  }

  if (isSentBySelf) {
    messageText = <>You: {messageText}</>;
  }

  return messageText;
};
